import { RadioGroup } from '@perch-labs/shrike';
import styled from 'styled-components';

export const MergerBannerWrapper = styled.div`
  grid-column: 1 / -1;
  margin: 0 auto 32px;
  width: 100%;

  ${props => props.theme.media.tabletLandscapeDown} {
    margin: 0 auto 24px;
    max-width: 480px;
    padding: 40px 16px 0;
    width: 100%;

    ${props => props.theme.media.largeScreenUp} {
      max-width: 600px;
    }
  }

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 0 24px;
  }
`;

export const MergerBanner = styled.div`
  align-items: center;
  background: #f2f4f1;
  border-radius: 10px;
  display: flex;
  gap: 32px;
  justify-content: flex-start;
  padding: 24px 32px;
  width: 100%;

  ${props => props.theme.media.tabletLandscapeDown} {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }
`;

export const MergerBannerLogos = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 16px;
`;

export const LogoSeparator = styled.span`
  color: ${props => props.theme.colors.content.primary};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  font-size: 20px;
  line-height: 1;
`;

export const MergerBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MergerBannerHeading = styled.h2`
  color: ${props => props.theme.colors.content.primary};
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: 16px;
  line-height: 1.4;
  margin: 0;
`;

export const MergerBannerSubtext = styled.p`
  color: ${props => props.theme.colors.content.secondary};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: inline-flex;
  gap: 1rem;
  legend {
    p {
      font-family: DM Sans Bold, sans-serif;
    }
  }
  label {
    p {
      font-family: DM Sans Regular, sans-serif;
    }
  }
`;
